import React from 'react';
import './LargeCard.css';
import LargeSliderImg1 from '../../Assets/c1.png';
import LargeSliderImg2 from '../../Assets/c2.png';
import LargeSliderImg3 from '../../Assets/c3.png';
import LargeSliderImg4 from '../../Assets/c4.png';



function LargeCards() {
    const LargeCards = [
            {
                id : 0,
                img : LargeSliderImg1,
                tittle : "ABOUT STS",
                para : "Sindh Testing Service has been established to undertake the responsibility of testing and assessment of institutions across the Sindh. The main object of STS is to endeavor for institutional development, progress and prosperity."
            },
            {
                id : 1,
                img : LargeSliderImg2,
                tittle : "PROFESSIONAL TESTS",
                para : "PT is designed to assess the Entry-Level Job seeker’s skill set to ensure that the candidate is the best applicant for hiring. Professional Test (PT) Score Card is the Standard for Employers to filter the candidates for their recruitment's."
            },
            {
                id : 2,
                img : LargeSliderImg3,
                tittle : "EDUCATIONAL TESTS",
                para : "Educational Tests (ET) is designed to assess the ability of students for admissions in universities / institutions. After passing this test, student will be eligible for admissions in universities / institutions in the specific course.."
            },
            {
                id : 3,
                img : LargeSliderImg4,
                tittle : "ONLINE EXAMINATION",
                para : "STS has developed the online examination system for conducting online tests."
            }
    ]
  return (
    <div className='LargeCards'>
        {LargeCards.map((item, index) => {
            return(
                <>
                 <div className='Large_Card1' id='key'> 
            <img className='LargeSliderImg' src={item.img} alt="" />
            <div className='Large_Slider_1'>
                <h5>{item.tittle}</h5>
                <p>
                    {item.para}
                </p>
            </div>
        </div>
                </>
            );
        })}
       
    </div>
  );
}

export default LargeCards
